// router/PublicRoute.tsx
import { Navigate } from "react-router-dom";
import {
  useIsLoading,
  useIsFullyAuthenticated,
  useInvitationStatus,
} from "@/store";

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const isLoading = useIsLoading();
  const isAuthenticated = useIsFullyAuthenticated();
  const invitationStatus = useInvitationStatus();

  // Show loading while checking authentication state
  if (isLoading) {
    let loadingMessage = "Loading...";

    if (invitationStatus === "checking") {
      loadingMessage = "Checking invitation...";
    } else if (invitationStatus === "processing") {
      loadingMessage = "Setting up your account...";
    }

    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-sm text-muted-foreground">{loadingMessage}</p>
        </div>
      </div>
    );
  }

  // Fully authenticated users should not access public routes
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // User has session but authentication failed due to invitation issues
  // Let them access public routes to potentially sign out or get help

  // No session = allow access to public routes
  return <>{children}</>;
};
